// @ts-nocheck
import React from "react";
import { Box, Button, IconButton, Modal, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Add } from "@mui/icons-material";
import ReimbursementAcc from "../../../../components/Accordions/ReimburesementAcc";
import { Close } from "@mui/icons-material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import LoadingOverlay from "../../../../components/Custom/LoadingOverlay";
import theme from "../../../../theme";
import DeductionAcc from "../../../../components/Accordions/DeductionAcc";
import NonTaxableAcc from "../../../../components/Accordions/NonTaxableAcc";

export function NonTaxableModal({
  open,
  handleClose,
  user,
  eventId,
  data,
  title = "",
  otherData,
}) {
  const [expanded, setExpanded] = React.useState(false);
  const [reimbursementForm, setReimbursementForm] = React.useState(data);
  const { eaLoading, arLoading } = useSelector(
    (state) => state.adjustmentsReducer,
  );

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  React.useEffect(() => {
    setReimbursementForm(Array.isArray(data) ? [...data].reverse() : []);
  }, [data]);

  const style = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    padding: 4,
    minWidth: "47%",
    backgroundColor: "#000",
    zIndiex: 9,
    borderRadius: "16px",
    border: "2px solid #D175B6",
    minHeight: "68%",
    width: "520px",
    maxHeight: "90vh",
    overflowY: "auto",
    "@media (max-width: 900px)": {
      width: "80%",
      minWidth: "0",
      height: "80%",
      overflowY: "auto",
    },
    "@media (max-width: 600px)": {
      width: "96%",
      minWidth: "0",
      height: "96%",
      overflowY: "auto",
    },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="reimbursement modal"
      aria-describedby="reimbursement modal"
    >
      <Box sx={style}>
        {eaLoading || arLoading ? (
          <LoadingOverlay open={true} />
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "0.75rem",
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, width: "100%" }}>
            <Typography
              sx={{
                color: "#FFF",
                fontSize: "1.5rem",
                fontWeight: "500",
                "@media(max-width: 600px)": {
                  fontSize: "1.4rem",
                  fontWeight: "400",
                },
              }}
            >
              {title}
            </Typography>

            {user === "contractor" ||
              (user == "admin" && (
                <Tooltip title="Create New Form" arrow placement="left">
                  <Button
                    className="btnPink"
                    sx={{
                      width: "auto !important",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      backgroundColor: "#D175B6",
                      borderRadius: "0.5rem",
                      padding: "1rem",
                      "&:hover": {
                        backgroundColor: "#D175B6",
                        opacity: 0.8,
                      },
                      "@media(max-width: 600px)": {
                        padding: "0.4rem",
                      },
                    }}
                    onClick={() => {
                      setReimbursementForm((prev) => {
                        return [
                          {
                            newValues: true,
                          },
                          ...prev,
                        ];
                      });
                      setExpanded("panel0");
                    }}
                  >
                    <Add
                      sx={{
                        color: "white",
                        fontSize: "20px",
                        "@media(max-width: 600px)": {
                          fontSize: "13px",
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        "@media(max-width: 600px)": {
                          display: "none",
                        },
                      }}
                    >
                      Add New
                    </Typography>
                  </Button>
                </Tooltip>
              ))}
            </Box>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "1rem",
                padding: "1.5rem",
                "@media(max-width: 600px)": {
                  padding: "0.1rem",
                },
              }}
            >
              {reimbursementForm?.map((data, index) => {
                return (
                  <div
                    style={{ position: "relative", width: "100%" }}
                    key={index}
                  >
                    <NonTaxableAcc
                      user={user}
                      expanded={expanded}
                      handleAccChange={handleChange}
                      data={{
                        ...data,
                        ...otherData,
                        reImbursementStatus:
                          data?.reImbursementStatus || "draft",
                      }}
                      setData={setReimbursementForm}
                      eventId={eventId}
                      isEditable={
                        !data?.reImbursementStatus ||
                        data?.reImburesmentStatus?.toLowerCase() === "draft"
                      }
                      index={index}
                      status={data?.reImbursementStatus || "draft"}
                    />
                    {(data?.reImbursementStatus === "draft" ||
                      !data?.reImbursementStatus) && (
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          right: "-10px",
                          backgroundColor: "#D175B6",
                          borderRadius: "50%",
                          padding: "1rem",
                          "&:hover": {
                            backgroundColor: "#D175B6",
                            opacity: 0.8,
                          },
                          height: "2rem",
                          width: "2rem",
                        }}
                        onClick={() => {
                          setReimbursementForm((prev) => {
                            return prev.filter((_, i) => i !== index);
                          });
                        }}
                      >
                        <Close sx={{ fontSize: "1rem", color: "white" }} />
                      </IconButton>
                    )}
                  </div>
                );
              })}
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
}

NonTaxableModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  user: PropTypes.string,
  eventId: PropTypes.string,
  data: PropTypes.array,
  otherData: PropTypes.object,
  title: PropTypes.string,
};